import React, { useEffect } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import DashboardLayouts from "../../Components/Layout/DashboardLayouts";

import Loader from "../../Components/Global/Loader";
import { useAuth } from "../../Context/AuthContext";
import Paginations from "../../hooks/Paginations";
import useAuthentication from "../../hooks/useAuthentication";
import useSearchListPagination from "../../hooks/useSearchListPagination";


const fieldNameData = [
    
          "Sl No.",
          "Unit Name",
          "Tenant Name",
          "Total Outstanding",
          "	Collected Amount for this month",
          "Date of Collection",
          "Status",
          "Payment Mode",
          "Collected By",
          "Transaction ID",
          "Action",
        ]
 
  const fieldValueData = 
  {
    id: "propertyDetails",
    value: [
      "unit_name",
      "tenant_name",
      "total_outstanding",
      "collected_amount",
      "DateOfCollection",
      "Status",
      "payment_mode",
      "Collected_By",
      "Transaction_ID",
    ],
    design: ["n", "n", "n", "n", "n"],
  }
    
  



  const allMonths = [
  
    {id:1, name:"January"},
    {id:2, name:"February"},
    {id:3, name:"March"},
    {id:4, name:"April"},
    {id:5, name:"May"},
    {id:6, name:"June"},
    {id:7, name:"July"},
    {id:8, name:"August"},
    {id:9, name:"September"},
    {id:10, name:"October"},
    {id:11, name:"November"},
    {id:12, name:"December"},
  ];







function AllUnitList({ allowedRoles }) {
  const { allowLoading } = useAuthentication(allowedRoles);
  const {id:unitId}=useParams()

  const {
    isKeyPress,
    setisKeyPress,
    Count,

    setsearchKey,
    searchKey,
    setRecord,
    record,
    setPages,
    pages,
   month,
   year,
   setMonth,
    PagesFunc,
    totallength,
   
    paginationLoading,
 
    setYear,
    SearchApi,
    allData,
    callAnyApi,

  } = useSearchListPagination();

  useEffect(() => {
    callAnyApi(`/accountant/Collection/unit/list/${unitId}`)
  }, [searchKey, record, pages,unitId,month,year]);

  const { designation } = useAuth();
 
  return (
    <>
      <DashboardLayouts>
        {(paginationLoading || allowLoading) && <Loader />}

        <div className="breadcrumb row justify-content-between align-items-center">
          <div className="d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
            <Link
              to={
                designation === "Owner" || designation === "Partner"
                  ? "/dashboard"
                  : `/${designation}dashboard`.toLowerCase()
              }
              className="d-flex align-items-center back-link"
            >
              <BsArrowLeft className="me-2 m-0 back-arrow" color="black" />
              <i className="icon-dashboard"></i>
              <h3 className="mb-0 fw-normal">Dashboard</h3>
            </Link>
          </div>
        </div>
        {/* ----- Body Content ---- */}
        <div className="list-data">
          <h1 className="heading-text mb-4">View All Unit</h1>
          {/* --- Data filter --- */}
          <div className="data-filters d-flex justify-content-between align-items-center mb-4">
            <div className="page-records d-flex align-items-center">
              <form action="" className="number">
                <select
                  className="number-box"
                  value={record}
                  name="record"
                  onChange={(event) => {
                    setRecord(event.target.value);
                    setPages(1);
                  }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                </select>
              </form>

              <h3 className="mb-0 ms-2 d-none d-sm-block">Records Per Page</h3>
            </div>
            <div className="page-records d-flex align-items-center">
              <form action="" className="number">
                <select
                  className="number-box"
                  value={month}
                  name="month"
                  onChange={(event) => {
                    setMonth(event.target.value);
                    setPages(1);
                  }}
                >
                  <option >Choose month</option>
                { allMonths.map(month=>(<option key={month.id} value={month.id}>{month.name}</option>)) }
               
                </select>
              </form>

              {/* <h3 className="mb-0 ms-2 d-none d-sm-block">Records Per Month</h3> */}
            </div>
            <div className="page-records d-flex align-items-center">
              <form action="" className="number">
                <select
                  className="number-box"
                  value={year}
                  name="year"
                  onChange={(event) => {
                    setYear(event.target.value);
                    setPages(1);
                  }}
                >
                  <option value='' >Choose Year</option>

                  {[...Array(5).keys()].map((value,ind) =>(<option >{(new Date()).getFullYear() - ind}</option>))}
              
               
                </select>
              </form>

              {/* <h3 className="mb-0 ms-2 d-none d-sm-block">Records Per Month</h3> */}
            </div>
            <div className="form search-bar1">
              <input
                type="search"
                className="form-control search-new"
                placeholder="search building name"
                aria-label="search"
                aria-describedby="search"
                name="searchKey"
                value={searchKey}
                onKeyDown={(e) => setisKeyPress(false)}
                onChange={(e) => setsearchKey(e.target.value.trimStart())}
              />
              <button
                className="search-btn fa-solid fa-magnifying-glass"
                type="submit"
                disabled={searchKey.trimStart() == ""}
                onClick={() => SearchApi("accountant_building_name")}
              >
                <FaSearch className="m-0 " color="#bebebe" />
              </button>
            </div>
          </div>
        </div>
        <div className="w-100 table-content overflow-auto">
          <table className="w-100">
            <thead>
              <tr>
          {fieldNameData.map(tName=>(
              <th key={tName} className="">{tName}</th>
          ))    
}
              
              
              </tr>
            </thead>

            <tbody>
              {allData?.length > 0 ? (
                allData?.map((items, i) => {
                  return (
                    <tr key={i} className={`border-b`}>

                        
                      <td className="">
                        {pages > 1 ? record * (pages - 1) + i + 1 : i + 1}
                      </td>
                 {  fieldValueData?.value?.map((TValue,index)=>(

                    <>
                    <td className="">{items[TValue]}</td>
                    </>
                   ))  }
                     

                      <td className="tex-center">
                        <ul className="table-icon d-flex justify-center text-center">
                          <li className="tex-center">
                            <Link
                              to={
                                designation == "Owner"
                                  ? `/owner/rent-collection/${items?.tenant_id}`
                                  : `/${designation?.toLowerCase()}/rent-collection/${items?.tenant_id}`
                              }
                            >
                              Make Payment
                            </Link>
                            </li>

                            <li>
                            

                       { items?.collected_amount !== 0  &&    <button
                            className="border px-5 py-2 ms-3 btn"
                              
                            >
                              Print
                            </button>}
                            </li>
                          



                        </ul>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
       

{Count > 5 && totallength.length > 1 && (
          <Paginations
            onPageChange={PagesFunc}
            currentPage={pages}
            totalPages={totallength.length}
          />
        )}
      </DashboardLayouts>
    </>
  );
}

export default AllUnitList;
